import dynamic from "next/dynamic";
const CardSecond = dynamic(() => import("./cardSecond"),{ssr: true});
const Card = dynamic(() => import("./card"),{ssr: true});
const CardImage = dynamic(() => import("./card-image"),{ssr: true});

interface overviewProps {
  data?: any;
}

const MakeUs: React.FC<overviewProps> = ({ data }) => {
  const desc = data.description.split("</p><p>");
  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[83px] overflow-hidden">
      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-center justify-center mx-auto">
          <h2 className="text-heading-3 font-bold text-primary-text mb-[24px] md:mt-[-25px]  max-w-[1230px] mx-auto">
            {data?.title ?? ""}
          </h2>

          <p className="text-subtitle-2 font-regular mt-3">
            {data?.title ?? ""}
          </p>

          <div className="grid lg:grid-cols-3 grid-cols-1 gap-0 mt-[48px] items-center w-full">
            <div className=" h-full">
              <Card desc={desc[0] ? desc[0] + "</p>" : ""} />
            </div>
            <div className=" h-full">
              <CardImage img={data?.Image?.data?.attributes?.url ?? ""} />
            </div>
            <div className=" h-full">
              <CardSecond desc={desc[1] ? "<p>" + desc[1] : ""} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MakeUs;
